import { render } from "./TrashedPostsToolbar.vue?vue&type=template&id=3a08a83e&ts=true"
import script from "./TrashedPostsToolbar.vue?vue&type=script&lang=ts"
export * from "./TrashedPostsToolbar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__